import React, { Component } from "react";

import { Dimmer, Loader } from "semantic-ui-react";


const BaresthoLoader = () => <Dimmer active><Loader /></Dimmer>;

// The most boilerplate file ive ever seen

class DynamicImport extends Component {
    state = {
        component: null
    };
    componentDidMount() {
        this.props.load()
            .then((component) => {
                this.setState(() => ({
                    component: component.default ? component.default : component
                }))
            })
    }
    render() {
        return this.props.children(this.state.component)
    }
}

// APP DYNAMIC IMPORTS
export const Login = (props) => (
    <DynamicImport load={() => import('./containers/Authentication/Login')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const NewPassword = (props) => (
    <DynamicImport load={() => import('./containers/Authentication/NewPassword')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const WebApp = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/WebApp')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);


// WEB APP DYNAMIC IMPORTS
export const Booker = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Booker/Booker')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const ReservationsHistory = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/ReservationsHistory/index')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const ReservationHistoryDetails = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/ReservationsHistory/ReservationHistoryDetails')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const Orders = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Orders/Orders')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const OrderSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Orders/OrderSettings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const OrderProducts = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Orders/OrderProducts')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const PastOrders = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Orders/PastOrders')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const TableSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Settings/GlobalTableSettings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const ScheduleSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Settings/ScheduleSettings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const ReservationSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Settings/ReservationsSettings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const ReservationPageSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Settings/ReservationPageSettings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const NotificationsSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Settings/NotificationsSettings/index')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const AccountSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Settings/AccountSettings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const ApplicationSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Settings/AppSettings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const Customers = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Customers/Customers')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const CustomerDetails = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Customers/CustomerDetails')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const EmailEditor = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Marketing/EmailEditor')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const Feedbacks = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Feedbacks/Feedbacks')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const SurveyEditor = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Feedbacks/SurveyEditor')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const Stats = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Stats/Stats')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);


export const StripeSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Integrations/StripeSettings/StripeSettings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);


export const GoogleSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Integrations/GoogleSettings/GoogleSettings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const PaymentsSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Payments/PaymentsSettings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const Messaging = (props) => (
    <DynamicImport load={() => import('./features/messaging/pages/Messaging')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const AnsweringMachine = (props) => (
    <DynamicImport load={() => import('./features/answering-machine/pages/Main')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const AnsweringMachineSettings = (props) => (
    <DynamicImport load={() => import('./features/answering-machine/pages/Settings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const SubscriptionSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Settings/SubscriptionSettingsRouter')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const UsersSettings = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/Settings/UsersSettings')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const ShopConfiguration = (props) => (
    <DynamicImport load={() => import('./features/shop/pages/ShopConfiguration')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const SMSHistory = (props) => (
    <DynamicImport load={() => import('./containers/WebApp/SMS/SMSHistory/index')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const ShopManagement = (props) => (
    <DynamicImport load={() => import('./features/shop/pages/ShopManagement')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const ShopStatistics = (props) => (
    <DynamicImport load={() => import('./features/shop/pages/ShopStatistics')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);
export const ShopInvoices = (props) => (
    <DynamicImport load={() => import('./features/shop/pages/ShopInvoices')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);

export const ShopSales = (props) => (
    <DynamicImport load={() => import('./features/shop/pages/ShopSales')}>
        {(Component) => Component === null
            ? <BaresthoLoader />
            : <Component {...props} />}
    </DynamicImport>
);


// WEBPACK FOOTER //
// ./src/DynamicImports.js